import { Common, ApiBind } from './common.model';

export class PassbackDesignTemplateRelation extends Common {

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'passback_id' })
  passbackId: number;
}
